import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IObjectControllableFeature, ILinkedPageObjectSpecifiable } from "../../../../documaker/domain/format/objects";

export interface ITranscribeDateOfTimeBehaviorPropertyEditable {
  transcribeDateOfTimeBehavior(): IPropertyEditable<IObjectControllableFeature<ILinkedPageObjectSpecifiable>>;
}

export function instanceOfITranscribeDateOfTimeBehaviorPropertyEditable(instance: any): instance is ITranscribeDateOfTimeBehaviorPropertyEditable {
  return instance
      && instance.transcribeDateOfTimeBehavior
      && instanceOfIPropertyEditable<IObjectControllableFeature<ILinkedPageObjectSpecifiable>>(instance.transcribeDateOfTimeBehavior());
}
